import { useState } from 'react';

const useObservationDraft = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [text, setText] = useState('');

  const open = () => setIsOpen(true);

  const close = () => {
    setIsOpen(false);
    setText('');
  };

  return { isOpen, text, setText, open, close };
};

export default useObservationDraft;
